<template>
  <div class="tab-container">
    <app-spinner v-if="!is_loaded" />
    <template v-else-if="transfers.length">
      <div v-for="(transfer_group, group_index) in transfers" :key="`${transfer_group.name}_${group_index}`">
        <app-cells v-if="transfer_group.name">
          <h2 class="title">{{ transfer_group.name }}</h2>
          <div v-if="transfer_group.today" class="status-title" :style="{ backgroundColor: '#77b017' }">Today</div>
        </app-cells>
        <transfers-blocks
          v-for="(transfer, index) in transfer_group.items"
          :key="transfer.id"
          :transfer="transfer"
          :count="index + 1"
          :is_show_arrange_button="false"
          :is_show_edit_cancel_buttons="false"
        />
      </div>
    </template>
    <div v-else class="no-results">
      <img src="@/assets/img/schedule-plug-icon.svg" alt="">
      <div class="no-results__title">No Results</div>
      <div class="no-results__text">There’s no transfers yet</div>
    </div>
  </div>
</template>

<script>
import { getSafariGroupTransfers } from '@/http'
import TransfersBlocks from '@/views/transfer/transfers/TransfersBlocks'

export default {
  name: 'SafariGroupTransfers',
  components: { TransfersBlocks },
  data() {
    return {
      is_loaded: false,
      transfers: [],
    }
  },
  created() {
    this.fetchItems()
  },
  methods: {
    fetchItems() {
      this.is_loaded = false
      getSafariGroupTransfers(this.$route.params.id, {
        range_type: 'day',
        group_by: 'pick_up_date',
      })
        .then(response => {
          this.transfers = response.data.results || response.data
        })
        .catch(() => {})
        .finally(() => { this.is_loaded = true })
    },
  }
}
</script>
